import axios from "axios";
import { localStorageInstance } from "../utils/storage";


const apiUrl = process.env.REACT_APP_API_URL;

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: apiUrl || "http://localhost:8010/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorageInstance.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is unauthorized and we haven't tried to refresh the token yet
    console.log("error api === ", error);
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Clear the token and redirect to login
      localStorageInstance.removeItem("token");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
